import React from 'react'

export default function Footer() {
  return (
    <>
        <footer className='w-[85%] h-[60px] flex *:w-full *:py-2 *:md:w-1/2 flex-wrap  md:justify-between items-center'>
                <div className=' flex items-center justify-center md:justify-start'>
                    <h5 className='capitalize text-[#A1B0CB]'>devlope by <b>khashayar madad</b></h5>
                </div>
                <ul className='flex justify-end items-center gap-2 *:font-medium *:text-[#A1B0CB] *:px-2'>
                     <li>لایسنس</li>       
                     <li>مستندات </li>       
                     <li>پشتیبانی</li>       
                     <li>قالبهای بیشتر</li>       
                </ul>
        </footer>
    </>
  )
}
